import { useEffect, useState } from "react";
import { Menu, Phone, X } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LINKS = [
  { label: "Services", href: "#services", id: "services" },
  { label: "Our Work", href: "#gallery", id: "gallery" },
  { label: "About", href: "#about", id: "about" },
  { label: "Contact", href: "#contact", id: "contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    axios.get(`${API}/branding`).then((r) => setLogo(r.data.logo_path)).catch(() => {});
  }, []);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/80 border-b border-black/5" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="font-outfit font-semibold tracking-tight text-slate-900 text-lg">
          {logo ? (
            <img src={`${API}/files/${logo}`} alt="ASAP Glass & Aluminium" className="h-16 w-auto" data-testid="nav-logo-image" />
          ) : (
            <>ASAP <span className="text-sky-500">Glass</span> &amp; Aluminium</>
          )}
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="tel:+61404179886"
            data-testid="nav-call-button"
            className="inline-flex items-center gap-2 bg-slate-900 text-white text-sm font-medium px-4 py-2 rounded-sm hover:bg-sky-500 transition-colors duration-200"
          >
            <Phone size={15} /> 0404 179 886
          </a>
        </nav>
        <button
          className="md:hidden text-slate-900"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-menu-button"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-black/5 px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => setOpen(false)}
              className="text-sm font-medium text-slate-700"
            >
              {l.label}
            </a>
          ))}
          <a href="tel:+61404179886" data-testid="nav-mobile-call-button" className="inline-flex items-center gap-2 text-sky-600 font-semibold text-sm">
            <Phone size={15} /> Call 0404 179 886
          </a>
        </div>
      )}
    </header>
  );
}
